import axios from 'axios';
import { getToken, logout } from './localstorage';

export const axiosEndPoint = axios;

const getBaseUrl = () => {
  
  if(process.env.NODE_ENV === 'production') {
    return 'https://app.detecno.com.sv/api/';
    //return 'https://elsalvador.detecno.com/api/';
  }

  return 'https://localhost:7011/';
};

const api = axios.create({
  baseURL: getBaseUrl(),
  timeout: 0,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json;charset=utf-8',
  },
});

api.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error)
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        logout();
        window.location.replace('/login')
      }
    }
    return Promise.reject(error);
  }
);

export default api;
